/*
  Elite Fanstore — flocages joueurs : moteur commun (assets/ef-joueurs.js)

  Bascule « Joueur | Mon flocage » et grille des joueurs de l'effectif, utilisée par :
    - la fiche produit, dans le volet de personnalisation (snippets/elite-joueurs.liquid) ;
    - la fenêtre « Éditer les options » d'APO au panier (snippets/elite-joueurs-panier.liquid).
  Choisir un joueur écrit son nom et son numéro dans les champs Nom et Numéro d'APO + input/change,
  exactement comme une saisie : prix, propriétés de commande et panier restent à APO. En mode Joueur,
  ces deux champs restent dans le formulaire, hors de vue (classe ej-joueur sur la racine).

  Effectifs : assets/ef-joueurs-<initiale de l'équipe>.js (window.EF_JOUEURS[initiale]), générés par
  Connection/build-joueurs.mjs ; envoi par Connection/deploy-joueurs.mjs.
*/
(function () {
  if (window.EFJ) return;

  var TXT = {
    fr: { joueur: 'Joueur', perso: 'Mon flocage', top: 'Les plus demandés', tout: 'Voir tout l’effectif ([n])', moins: 'Réduire', effectif: 'Effectif [s]', G: 'Gardiens', D: 'Défenseurs', M: 'Milieux', A: 'Attaquants' },
    en: { joueur: 'Player', perso: 'Custom', top: 'Most popular', tout: 'See full squad ([n])', moins: 'Show less', effectif: 'Squad [s]', G: 'Goalkeepers', D: 'Defenders', M: 'Midfielders', A: 'Forwards' },
    es: { joueur: 'Jugador', perso: 'Personalizado', top: 'Los más pedidos', tout: 'Ver toda la plantilla ([n])', moins: 'Ver menos', effectif: 'Plantilla [s]', G: 'Porteros', D: 'Defensas', M: 'Centrocampistas', A: 'Delanteros' },
    de: { joueur: 'Spieler', perso: 'Individuell', top: 'Am beliebtesten', tout: 'Ganzen Kader anzeigen ([n])', moins: 'Weniger anzeigen', effectif: 'Kader [s]', G: 'Torhüter', D: 'Abwehr', M: 'Mittelfeld', A: 'Angriff' },
    it: { joueur: 'Giocatore', perso: 'Personalizzato', top: 'I più richiesti', tout: 'Vedi tutta la rosa ([n])', moins: 'Mostra meno', effectif: 'Rosa [s]', G: 'Portieri', D: 'Difensori', M: 'Centrocampisti', A: 'Attaccanti' },
    pt: { joueur: 'Jogador', perso: 'Personalizado', top: 'Os mais procurados', tout: 'Ver o plantel completo ([n])', moins: 'Ver menos', effectif: 'Plantel [s]', G: 'Guarda-redes', D: 'Defesas', M: 'Médios', A: 'Avançados' },
    sv: { joueur: 'Spelare', perso: 'Eget tryck', top: 'Mest populära', tout: 'Visa hela truppen ([n])', moins: 'Visa färre', effectif: 'Trupp [s]', G: 'Målvakter', D: 'Försvarare', M: 'Mittfältare', A: 'Anfallare' }
  };
  var LIGNES = ['G', 'D', 'M', 'A'];
  var CHEV = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="m6 9 6 6 6-6"></path></svg>';

  function norm(v) {
    return String(v || '').normalize('NFD').replace(/[̀-ͯ]/g, '').toLowerCase();
  }
  function yy(n) { return String(n).slice(-2); }

  /* Même lecture des années que Connection/build-joueurs.mjs (anneesDe) :
     sert seulement aux produits ajoutés après la dernière génération. */
  function annees(titre) {
    var t = norm(titre), m;
    if ((m = t.match(/\b(19[4-9]\d|20[0-3]\d)\s*[/-]\s*(\d{2,4})\b/))) {
      var a = +m[1], b = a - (a % 100) + +m[2].slice(-2);
      if (b < a) b += 100;
      if (b <= a || b - a > 3) b = a + 1;
      return { a: a, b: b };
    }
    if ((m = t.match(/\b(\d{2})\/(\d{2})\b/))) { var c = +m[1] > 30 ? 1900 + +m[1] : 2000 + +m[1]; return { a: c, b: c + 1 }; }
    if ((m = t.match(/\b(19[4-9]\d|20[0-3]\d)\b/))) return { a: +m[1], b: null };
    return null;
  }

  /* L'effectif d'un produit { handle, equipe, titre } : par son handle (générateur), sinon par
     l'équipe et l'année du titre, sinon la saison la plus récente de l'équipe. */
  function effectifDe(data, p) {
    var u = data.u || [];
    var i = data.p ? data.p[p.handle] : undefined;
    if (typeof i === 'number' && u[i]) return u[i];
    var base = 'foot|' + p.equipe + '|';
    var par = {};
    u.forEach(function (x) { par[x.id] = x; });
    var an = annees(p.titre), cles = [];
    if (an) {
      if (an.a >= 2024) cles.push(an.b ? an.a + '-' + yy(an.b) : (an.a - 1) + '-' + yy(an.a), an.a + '-' + yy(an.a + 1));
      if (an.a >= 2025) cles.push('actuel');
      cles.push(an.b ? an.a + '-' + yy(an.b) : String(an.a));
      if (an.a === 2024) cles.push('2024');
    }
    for (var k = 0; k < cles.length; k++) if (par[base + cles[k]]) return par[base + cles[k]];
    if (!an || an.a >= 2024) {
      var d = data.d && data.d[p.equipe];
      if (d && par[base + d]) return par[base + d];
    }
    return null;
  }

  /* maillot gardien : les gardiens en tête (titre dans la langue du visiteur, ou handle) */
  function gardien(p) {
    return /\b(gardien|goalkeeper|keeper|portero|torwart|portiere|guarda-redes|goleiro|malvakt)\b/.test(norm(p.titre) + ' ' + String(p.handle || '').replace(/-/g, ' '));
  }

  /* Fichier de données d'une initiale, chargé une seule fois par balise script */
  var attentes = {};
  function charge(lettre, url, cb) {
    var pret = window.EF_JOUEURS && window.EF_JOUEURS[lettre];
    if (pret) { cb(pret); return; }
    if (attentes[lettre]) { attentes[lettre].push(cb); return; }
    attentes[lettre] = [cb];
    var fin = function () {
      var d = (window.EF_JOUEURS && window.EF_JOUEURS[lettre]) || null;
      var l = attentes[lettre] || [];
      attentes[lettre] = null;
      l.forEach(function (f) { f(d); });
    };
    var s = document.createElement('script');
    s.src = url;
    s.async = true;
    s.onload = fin;
    s.onerror = fin;
    document.head.appendChild(s);
  }

  /* Champs Nom et Numéro d'APO sous une racine : par leur libellé (FR, EN…), sinon les deux
     premiers champs texte. Les patchs (texte masqué sous la grille de photos) sont écartés. */
  function champs(racine) {
    if (!racine) return {};
    var nom = null, num = null, textes = [];
    Array.prototype.forEach.call(racine.querySelectorAll('.mw-option'), function (o) {
      var input = o.querySelector('input.mw-option__control[type="text"], input.mw-option__control[type="number"]');
      if (!input || o.classList.contains('ef-patchs')) return;
      var lab = norm((o.querySelector('.mw-text--style-strong') || {}).textContent).trim();
      if (/patch|parche/.test(lab)) return;
      textes.push(o);
      if (/sous|under|texto|unter|sotto/.test(lab)) return;
      if (!nom && /^(nom|name|nombre|nome|namn)\b/.test(lab)) nom = o;
      else if (!num && /^(num|number|nummer|nr|n°)/.test(lab)) num = o;
    });
    if (!nom && textes[0]) nom = textes[0];
    if (!num && textes[1] && textes[1] !== nom) num = textes[1];
    return {
      nomOpt: nom, numOpt: num,
      nom: nom && nom.querySelector('input.mw-option__control'),
      num: num && num.querySelector('input.mw-option__control')
    };
  }

  function ecris(input, v) {
    if (!input || input.value === v) return;
    input.value = v;
    input.dispatchEvent(new Event('input', { bubbles: true }));
    input.dispatchEvent(new Event('change', { bubbles: true }));
  }

  function parNumero(a, b) { return a[1] - b[1]; }

  /* Joueurs proposés : seulement les gardiens sur un maillot gardien, jamais de gardien sur un maillot joueur */
  function joueursPour(effectif, estGardien) {
    return (effectif && effectif.j || []).filter(function (j) { return estGardien ? j[2] === 'G' : j[2] !== 'G'; });
  }

  /* Monte la bascule et la grille.
     o = { effectif, gardien, locale, racine(): élément qui porte la classe ej-joueur,
           options(): élément qui contient les options APO }
     Rend { el, applique(), marque() } : l'appelant place el et rappelle applique() après chaque
     rendu d'APO (changement de taille, réouverture de la fenêtre…). */
  function monte(o) {
    var T = TXT[String(o.locale || 'fr').slice(0, 2)] || TXT.fr;
    var effectif = { l: o.effectif.l, j: joueursPour(o.effectif, o.gardien) };
    var mode = 'joueur', tout = false;
    var nomDe = function (j) { return j[0]; };
    var numDe = function (j) { return String(j[1]); };

    function joueurChoisi() {
      var c = champs(o.options());
      if (!c.nom || !c.num) return null;
      var n = String(c.nom.value || '').trim().toUpperCase(), x = String(c.num.value || '').trim();
      if (!n && !x) return false;
      for (var k = 0; k < effectif.j.length; k++) {
        if (nomDe(effectif.j[k]) === n && numDe(effectif.j[k]) === x) return effectif.j[k];
      }
      return undefined;
    }

    function tuile(j) {
      var b = document.createElement('button');
      b.type = 'button';
      b.className = 'ej__j';
      b.setAttribute('data-k', nomDe(j) + '|' + numDe(j));
      b.setAttribute('aria-pressed', 'false');
      b.setAttribute('aria-label', nomDe(j) + ' ' + numDe(j));
      b.innerHTML = '<span class="ej__num"></span><span class="ej__nom"></span>';
      b.querySelector('.ej__num').textContent = numDe(j);
      b.querySelector('.ej__nom').textContent = nomDe(j);
      b.__j = j;
      return b;
    }
    function grille(liste) {
      var g = document.createElement('div');
      g.className = 'ej__grille';
      liste.forEach(function (j) { g.appendChild(tuile(j)); });
      return g;
    }
    function bloc(titre, liste, extra) {
      var s = document.createElement('div');
      s.className = 'ej__ligne';
      var tete = document.createElement('div');
      tete.className = 'ej__tete';
      tete.innerHTML = '<span class="ej__titre"></span>';
      tete.firstChild.textContent = titre;
      if (extra) {
        var e = document.createElement('span');
        e.className = 'ej__saison';
        e.textContent = extra;
        tete.appendChild(e);
      }
      s.appendChild(tete);
      s.appendChild(grille(liste));
      return s;
    }

    var joueurs = effectif.j.slice();
    /* en tête : les vedettes (dans leur ordre), ou tous les gardiens sur un maillot gardien */
    var tete = o.gardien
      ? joueurs.sort(parNumero)
      : joueurs.filter(function (j) { return j[3] > 0; }).sort(function (a, b) { return a[3] - b[3]; });
    if (!tete.length) tete = joueurs.slice().sort(parNumero).slice(0, 8);
    var reste = joueurs.filter(function (j) { return tete.indexOf(j) < 0; });

    var ui = document.createElement('div');
    ui.className = 'ej';
    ui.innerHTML =
      '<div class="ej__modes">' +
        '<button type="button" class="ej__mode" data-mode="joueur"></button>' +
        '<button type="button" class="ej__mode" data-mode="perso"></button>' +
      '</div>' +
      '<div class="ej__liste">' +
        '<div class="ej__haut"></div>' +
        '<div class="ej__bas" hidden></div>' +
        '<button type="button" class="ej__plus" aria-expanded="false"><span></span>' + CHEV + '</button>' +
      '</div>';
    ui.querySelector('[data-mode="joueur"]').textContent = T.joueur;
    ui.querySelector('[data-mode="perso"]').textContent = T.perso;
    ui.querySelector('.ej__haut').appendChild(bloc(o.gardien ? T.G : T.top, tete, effectif.l ? T.effectif.replace('[s]', effectif.l) : ''));
    var bas = ui.querySelector('.ej__bas');
    LIGNES.forEach(function (l) {
      var liste = reste.filter(function (j) { return j[2] === l; }).sort(parNumero);
      if (liste.length) bas.appendChild(bloc(T[l], liste));
    });
    /* sur téléphone, une seule ligne (3) au départ : le bouton sert aussi à dérouler la tête de liste */
    if (!reste.length) {
      ui.classList.add('ej--sans-reste');
      if (tete.length <= 3) ui.querySelector('.ej__plus').hidden = true;
    }

    function libellePlus() {
      var plus = ui.querySelector('.ej__plus');
      plus.querySelector('span').textContent = tout ? T.moins : T.tout.replace('[n]', effectif.j.length);
      plus.setAttribute('aria-expanded', String(tout));
    }
    function deplie(on) {
      tout = on;
      ui.classList.toggle('is-tout', on);
      bas.hidden = !on;
      libellePlus();
    }
    function marque() {
      var j = joueurChoisi();
      var k = j ? nomDe(j) + '|' + numDe(j) : '';
      Array.prototype.forEach.call(ui.querySelectorAll('.ej__j'), function (b) {
        /* seulement si ça change : applique() est rappelé à chaque mutation d'APO */
        var v = String(b.getAttribute('data-k') === k);
        if (b.getAttribute('aria-pressed') !== v) b.setAttribute('aria-pressed', v);
      });
    }
    function choisisJoueur(j) {
      var c = champs(o.options());
      if (!c.nom || !c.num) return;
      var deja = joueurChoisi() === j;
      ecris(c.nom, deja ? '' : nomDe(j));
      ecris(c.num, deja ? '' : numDe(j));
      marque();
    }
    /* À chaque rendu d'APO : repérer les champs, les masquer en mode Joueur, remettre la sélection */
    function applique() {
      var racine = o.racine();
      var options = o.options();
      if (!racine || !options) return;
      var c = champs(options);
      Array.prototype.forEach.call(options.querySelectorAll('.mw-option.ej-champ'), function (x) {
        if (x !== c.nomOpt && x !== c.numOpt) x.classList.remove('ej-champ');
      });
      if (c.nomOpt && !c.nomOpt.classList.contains('ej-champ')) c.nomOpt.classList.add('ej-champ');
      if (c.numOpt && !c.numOpt.classList.contains('ej-champ')) c.numOpt.classList.add('ej-champ');
      var cacher = mode === 'joueur' && !!(c.nom && c.num);
      if (racine.classList.contains('ej-joueur') !== cacher) racine.classList.toggle('ej-joueur', cacher);
      marque();
    }
    function choisisMode(m, parClic) {
      mode = m;
      Array.prototype.forEach.call(ui.querySelectorAll('.ej__mode'), function (b) {
        b.setAttribute('aria-pressed', String(b.getAttribute('data-mode') === m));
      });
      ui.querySelector('.ej__liste').hidden = m !== 'joueur';
      applique();
      if (parClic && m === 'perso') {
        var c = champs(o.options());
        if (c.nom) c.nom.focus({ preventScroll: true });
      }
    }

    ui.addEventListener('click', function (e) {
      var m = e.target.closest('.ej__mode');
      if (m) { choisisMode(m.getAttribute('data-mode'), true); return; }
      if (e.target.closest('.ej__plus')) { deplie(!tout); return; }
      var t = e.target.closest('.ej__j');
      if (t) choisisJoueur(t.__j);
    });
    libellePlus();
    /* une saisie libre déjà présente (taille changée, ligne déjà floquée) : on la montre */
    choisisMode(joueurChoisi() === undefined ? 'perso' : 'joueur');

    return { el: ui, applique: applique, marque: marque };
  }

  window.EFJ = { charge: charge, effectifDe: effectifDe, gardien: gardien, champs: champs, monte: monte, joueursPour: joueursPour };
})();
